module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.dataList), function(data) {
    return _c('div', [_c('div', {
      staticClass: "flexbetween"
    }, [_c('div', {}, [_c('h1', {
      staticClass: "dictionary-result-main-title",
      domProps: {
        "innerHTML": _vm._s(_vm.changeTag(data.word))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-phonetic",
      domProps: {
        "innerHTML": _vm._s(_vm.changeTag(data.pronunciation))
      }
    })]), _vm._v(" "), (data.alcRank.length != 0) ? _c('img', {
      staticClass: "img-svl",
      attrs: {
        "src": data.alcRank
      }
    }) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "mb30",
      domProps: {
        "innerHTML": _vm._s(_vm.changeTag(data.variationData))
      }
    }), _vm._v(" "), _vm._l((data.partOfSpeeches), function(partOfSpeech) {
      return _c('div', {
        staticClass: "mb30"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(_vm.changeTag(partOfSpeech.partOfSpeech))
        }
      }), _vm._v(" "), _vm._l((partOfSpeech.linesData), function(linesData) {
        return _c('div', _vm._l((linesData), function(lines) {
          return _c('div', {
            staticClass: "mb30"
          }, [_c('p', {
            staticClass: "bold font-large",
            domProps: {
              "innerHTML": _vm._s(_vm.changeTag(lines.text))
            }
          }), _vm._v(" "), _vm._l((lines.lineChildren), function(child) {
            return _c('div', [_c('p', {
              staticClass: "bold",
              domProps: {
                "innerHTML": _vm._s(_vm.changeTag(child.childText))
              }
            }), _vm._v(" "), _c('p', {
              staticClass: "ml20",
              domProps: {
                "innerHTML": _vm._s(_vm.changeTag(child.examples.example))
              }
            }), _vm._v(" "), _vm._l((child.examples.columns), function(column) {
              return _c('div', {
                staticClass: "section-column"
              }, [_c('img', {
                staticClass: "img-section-column",
                attrs: {
                  "src": "static/images/icon/png/dictionary_column.png"
                }
              }), _vm._v(" "), _c('p', {
                staticClass: "title-section-column",
                domProps: {
                  "innerHTML": _vm._s(_vm.changeTag(column.title))
                }
              }), _vm._v(" "), _c('p', {
                staticClass: "ml30",
                domProps: {
                  "innerHTML": _vm._s(_vm.changeTag(column.content))
                }
              })])
            })], 2)
          })], 2)
        }), 0)
      })], 2)
    })], 2)
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8155bed0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-8155bed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dictionary/WordResult.vue
// module id = 725
// module chunks = 1